import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { Locale } from '@fastnorth/i18next';
import { Div } from '@fastnorth/kraken/components/layout';
import formatProgressCount from '../utils/formatProgressCount';
import { statusTotalsRootVariants, statusTotalsTextVariants } from './StatusTotals.styles';

export type StatusTotalsProps = {
  dnfCount: number;
  dnsCount: number;
  dqCount: number;
};

const StatusTotals = ({ dnfCount, dnsCount, dqCount }: StatusTotalsProps): ReactElement => {
  const { i18n, t } = useTranslation('translation', { keyPrefix: 'karwa.event_progress_v2' });
  const locale = i18n.language as Locale;

  return (
    <Div className={statusTotalsRootVariants()}>
      <span className={statusTotalsTextVariants()}>
        {t('status_totals', {
          dnf: formatProgressCount(dnfCount, locale),
          dns: formatProgressCount(dnsCount, locale),
          dq: formatProgressCount(dqCount, locale),
          dqLabel: t('dq_label'),
        })}
      </span>
    </Div>
  );
};

export default StatusTotals;
